import { Injectable, inject } from '@angular/core';
import {
  CreateAndUpdateOrderShareRequest,
  OrderSharingService,
  SharedRecipient,
  SharedRecipientDetails,
} from '@compumark/order-management-client';
import { BehaviorSubject, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharingService {
  private orderSharingService = inject(OrderSharingService);

  private sharingEnabledSubject$ = new BehaviorSubject<boolean>(false);
  private cachedRecipients$?: Observable<Array<SharedRecipient>>;

  constructor() {
    this.orderSharingService
      .isSharingEnabled()
      .subscribe((isSharingEnabled) => {
        this.sharingEnabledSubject$.next(isSharingEnabled);
      });
  }

  isSharingFeatureEnabledForCurrentMemberObservable(): Observable<boolean> {
    return this.sharingEnabledSubject$.asObservable();
  }

  isSharingFeatureEnabledForCurrentMember(): boolean {
    return this.sharingEnabledSubject$.value;
  }

  hasSharedResults(): Observable<boolean> {
    return this.orderSharingService.hasSharedResults();
  }

  saveOrderShare(
    saveOrderShare: CreateAndUpdateOrderShareRequest,
  ): Observable<Record<string, SharedRecipientDetails[]>> {
    return this.orderSharingService.saveOrderShare(
      saveOrderShare,
    ) as Observable<Record<string, SharedRecipientDetails[]>>;
  }

  getRecipients(): Observable<Array<SharedRecipient>> {
    if (!this.cachedRecipients$) {
      this.cachedRecipients$ = this.orderSharingService
        .getSharedRecipients()
        .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    return this.cachedRecipients$;
  }
}
